import { Injectable } from '@angular/core';
import { Config } from '../config';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Dictionary, Role } from '../models';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    private config: Config,
    private http: HttpClient
  ) { }

  getCarParks(): Observable<Dictionary<number, string>[]> {
    return this.http.get<Dictionary<number, string>[]>(this.config.get('API_SERVER_URL') + '/commons/carparks');
  }

  getCompanies(): Observable<any> {
    return this.http.get(this.config.get('API_SERVER_URL') + '/commons/tenants');
  }

  getAllRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(this.config.get('API_SERVER_URL') + '/commons/roles');
  }

  getCarparkUsers(idCompany: number): Observable<any[]> {
    return this.http.get<any[]>(this.config.get('API_SERVER_URL') + `/commons/carpark-users/${idCompany}`)
  }
}
